import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonSelect from "../../../components/forms/CommonSelect";
import PropTypes from "prop-types";

function AlterarMunicipioModal({
  modalHook,
  modalValues,
  estados,
  municipios,
  alterarMunicipio,
}) {
  const { alterarMunicipioValues, setAlterarMunicipioValues } = modalValues;
  const { alterarMunicipioModal, setAlterarMunicipioModal } = modalHook;

  return (
    <CommonModal
      title="Alterar município de incidência"
      is_open_modal={alterarMunicipioModal}
      set_is_open_modal={setAlterarMunicipioModal}
      size="md"
      buttons={[
        <CommonButton
          key={`salvar-municipio`}
          onClick={alterarMunicipio}
          color="success"
        >
          Salvar
        </CommonButton>,
      ]}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          alterarMunicipio();
        }}
      >
        <div className="row">
          <div className="col-6">
            <CommonSelect
              label="Estado"
              id="estado"
              value={alterarMunicipioValues.estadoId}
              onChange={(e) => {
                const selectedEstadoId = e.target.value;
                const selectedEstadoName =
                  e.target.options[e.target.selectedIndex]?.text;

                setAlterarMunicipioValues((alterarMunicipioValues) => ({
                  ...alterarMunicipioValues,
                  estado: selectedEstadoName,
                  estadoId: selectedEstadoId,
                }));
              }}
              data={
                estados &&
                Object.keys(estados).map((estadoKey) => ({
                  text: estados[estadoKey].nome,
                  id: estados[estadoKey].id,
                }))
              }
              placeholder="Selecione o estado"
            />
          </div>
          <div className="col-6">
            <CommonSelect
              label="Município"
              id="municipio"
              value={alterarMunicipioValues.municipioId}
              onChange={(e) => {
                const opcaoSelecionada =
                  e.target.options[e.target.selectedIndex];
                const selectedMunicipioId = e.target.value;
                const selectedMunicipioName = opcaoSelecionada?.text;
                const selectedEstadoSigla = opcaoSelecionada?.dataset?.uf;

                setAlterarMunicipioValues((alterarMunicipioValues) => ({
                  ...alterarMunicipioValues,
                  municipio: selectedMunicipioName,
                  municipioId: selectedMunicipioId,
                  estadoSigla: selectedEstadoSigla,
                }));
              }}
              data={
                municipios &&
                Object.keys(municipios).map((estadoKey) => ({
                  text: municipios[estadoKey].nome,
                  id: municipios[estadoKey].id,
                  "data-uf":
                    municipios[estadoKey]["microrregiao"]["mesorregiao"]["UF"][
                      "sigla"
                    ],
                }))
              }
              placeholder="Selecione o município"
            />
          </div>
        </div>
      </form>
    </CommonModal>
  );
}

AlterarMunicipioModal.propTypes = {
  modalHook: PropTypes.shape({
    alterarMunicipioModal: PropTypes.bool.isRequired,
    setAlterarMunicipioModal: PropTypes.func.isRequired,
  }).isRequired,
  modalValues: PropTypes.shape({
    alterarMunicipioValues: PropTypes.object.isRequired,
    setAlterarMunicipioValues: PropTypes.func.isRequired,
  }).isRequired,
  estados: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      nome: PropTypes.string.isRequired,
    })
  ).isRequired,
  municipios: PropTypes.objectOf(PropTypes.object).isRequired,
  alterarMunicipio: PropTypes.func.isRequired,
};

export default AlterarMunicipioModal;
